import { Component, OnInit, ViewChild } from '@angular/core';
import { Canal } from '../../_models/canal';
import { CanalService } from '../../_services/canal.service';
import { NavService } from '../../_services/_nav.service';
import { Table } from 'primeng/table';
import { Router } from '@angular/router';
import { Funcionalidad } from '../../_models/funcionalidad';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { ConstanteService} from '../../_services/constante.service';
import { Constante } from '../../_models/constante';
import {forkJoin} from 'rxjs';
import { ExcepcionGmfService } from '../../_services/excepcion-gmf.service';
import { ExcepcionGMF } from '../../_models/excepcion-gmf';

@Component( {
  selector: 'app-excepciones-gmf',
  templateUrl: 'excepciones-gmf-listado.component.html',
  styleUrls: [ 'excepciones-gmf-listado.component.scss' ]
} )

export class ExcepcionesGmfListadoComponent implements OnInit {

  excepcionesGmf: ExcepcionGMF [] = [];
  constGMF: any;
  carExcepciones = true;
  columnas: any[];
  busqueda: string;
  @ViewChild('dt', { static: true }) tabla: Table;
  menu: Funcionalidad = new Funcionalidad();

  constructor( private excepcionesGmfService: ExcepcionGmfService,
               private navServicio: NavService,
               private autServicio: AutenticacionService,
               private constServicio: ConstanteService,
               private router: Router ) {
  }

  ngOnInit(): void {

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/excepciones-gmf' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'EXCEPCIONESGMF.LBL_CODIGO' ), sort: false },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'EXCEPCIONESGMF.LBL_NOMBRE' ), sort: true },
      { field: 'descripcion', header: this.navServicio.buscarMensaje( 'EXCEPCIONESGMF.LBL_DESCRIPCION' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: true },
      { field: 'acciones', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];
    this.busqueda = this.navServicio.getSearch( 'canales.component' );

    // Cargando información inicial datatable y constante GMF
    forkJoin( this.excepcionesGmfService.listado(),
      this.constServicio.getByCode('GMF')).subscribe(
      ([ excepciones, constante ]) => {
        this.excepcionesGmf = excepciones;
        this.carExcepciones = false;
        this.constGMF = constante;
        this.tabla.filterGlobal( this.busqueda, 'contains' );
      }
    );
  }

  crearExcepcionGMF() {
    this.router.navigate(['apl/excepciones-gmf/agregar']);
  }

  verExcepcionGMF( excep: ExcepcionGMF ) {
    this.router.navigate( [ 'apl/excepciones-gmf/detalle/' + excep.idExcepcionGMF ] );
  }

  editarExcepcionGMF( excep: ExcepcionGMF ) {
    this.router.navigate( [ 'apl/excepciones-gmf/actualizar/' + excep.idExcepcionGMF ] );
  }

  setBusqueda() {
    this.navServicio.setSearch( 'excepciones-gmf.component', this.busqueda );
  }

}
